import { render, staticRenderFns } from "./side.vue?vue&type=template&id=569428b1&scoped=true"
var script = {}
import style0 from "./side.vue?vue&type=style&index=0&id=569428b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569428b1",
  null
  
)

export default component.exports